export default __webpack_public_path__ + "static/media/textWaterMarks.87b5d238.svg";